import axios from "axios";
import { wmSign, wmAes, wm_aes_for_web } from "../../apiFunc/encrypt";
import { decrypt } from "../../apiFunc/decrypt";
import { EncryptRelay } from "../EncryptRelay/EncryptRelay";
import { GetTimeStamp } from "../../apiFunc/getDate";

const appURL = `${process.env.REACT_APP_APP_URL}/api`;
const oauthURL = `${process.env.REACT_APP_OAUTH_URL}/api`;
const appId = process.env.REACT_APP_ID;
const deviceUuid = process.env.REACT_APP_DEVICE_UUID;
const apiKey = process.env.REACT_APP_API_KEY;

const baseHeader = {
  "Content-Type": "application/json",
  "Accept-Language": "zh-TW",
  "app-id": appId,
  "device-uuid": deviceUuid,
};

/**Third party api */
async function Login(datatest) {
  const body = {
    request_parameter: {
      account: wmAes(datatest.account),
      password: wmAes(datatest.password),
    },
    timestamp: GetTimeStamp(),
  };
  const sign = wmSign(body);
  const data = {
    sign: sign,
  };
  const response = await axios.post(`${appURL}/member/login`, data, {
    headers: baseHeader,
  });
  return response.data;
}

// WS01

// WS06
async function checkMobile(datatest) {
  const url = "/app/checkMobile";
  const body = {
    Q1: wmAes(datatest.account),
    K: apiKey,
    F: "JSON",
  };
  const payload = {
    http_method: "POST",
    merchant: "HTY",
    header: null,
    request_body_type: "x-www-form-urlencoded",
    body: body,
  };
  const response = await EncryptRelay({
    thirdPartyUrl: url,
    thirdPartyPayload: payload,
  });
  const { rcrm, results } = response;
  if (rcrm.RC === "C01") {
    return decrypt(results.data.payload);
  } else {
    return "error";
  }
}

// WS51
async function forgetPassword(datatest) {
  const url = "app/forget";

  const body = {
    Q1: datatest.mobile,
    K: apiKey,
    // F: "JSON",
  };
  const payload = {
    http_method: "POST",
    merchant: "HTY",
    header: null,
    request_body_type: "x-www-form-urlencoded",
    body: body,
  };
  const response = await EncryptRelay({
    thirdPartyUrl: url,
    thirdPartyPayload: payload,
  });
  const { rcrm, results } = response;
  const decryptResult = decrypt(results.data.payload);
  if (rcrm.RC === "C01") {
    return { RC: rcrm.RC, RM: rcrm.RM, result: JSON.parse(decryptResult) };
  } else {
    return { RC: rcrm.RC, RM: rcrm.RM, result: null };
  }
}

export { checkMobile, forgetPassword };
